import Button from "../../Shared/Button/Button";
import FilterHeader from "../../Shared/FilterHeader/FilterHeader";
import InputForm from "../Common/InputForm";

const UserAccountInfo = () => {
  return (
    <div className="col-span-3 mt-[60px]">
      <FilterHeader title={"Account Information"} dropdown={false} />
      <div>
        <InputForm title={"Username"} />
        <InputForm title={"Name"} />
        <InputForm title={"Last Name"} />
        <InputForm title={"E-mail"} />
        <InputForm title={"Phone Number"} />
        <InputForm title={"City"} />
        <InputForm title={"Suburb"} />
        <InputForm title={"Address"} />
        <InputForm title={"Date"} />
        <InputForm title={"Password Change"} required />
        <InputForm title={"Password"} required />
        <InputForm title={"Confirm Password"} required />
      </div>
      <div className="flex justify-end gap-4">
        <Button
          text={"Edit"}
          variant="outline"
          className="mb-[60px] mt-10 !w-1/5 !border-darkGreen !text-2xl !text-darkGreen"
        />
        <Button
          text={"Save"}
          variant="primary"
          className="mb-[60px] mt-10 !w-1/5 !text-2xl"
        />
      </div>
    </div>
  );
};

export default UserAccountInfo;
